import { render, staticRenderFns } from "./PointStyleDefinition.vue?vue&type=template&id=924c361e&scoped=true"
import script from "./PointStyleDefinition.vue?vue&type=script&lang=ts"
export * from "./PointStyleDefinition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924c361e",
  null
  
)

export default component.exports